import React, { useCallback, useState } from 'react'
import clsx from 'clsx'

import { EditorProps } from '../../../types'
import { TAB_KEY, ESC_KEY, ENTER_KEY } from '../../../utils/keys'

export interface Props extends EditorProps<Date> {
  className?: string
  style?: React.CSSProperties
}

const DateEditor: React.FC<Props> = ({ value, onChange, className, style }) => {
  const [inputValue, setInputValue] = useState(
    value ? value.toISOString().split('T')[0] : undefined,
  )

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value)
    },
    [],
  )

  const handleBlur = useCallback(() => {
    onChange(inputValue ? new Date(inputValue) : undefined)
  }, [inputValue, onChange])

  const handleKeyDown = useCallback(
    ({ keyCode }: React.KeyboardEvent<HTMLInputElement>) => {
      if (keyCode === TAB_KEY || keyCode === ESC_KEY || keyCode === ENTER_KEY) {
        handleBlur()
      }
    },
    [handleBlur],
  )

  return (
    <input
      data-testid="date-editor-input"
      autoFocus
      className={clsx(
        'w-full h-full text-sm focus:outline-none bg-transparent',
        className,
      )}
      style={style}
      type="date"
      value={inputValue}
      onBlur={handleBlur}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  )
}

export default DateEditor
